import dynamic from "next/dynamic";
import { AiOutlineClose } from "react-icons/ai";
import VerificationSteps from "../VerificationSteps";

const Modal = dynamic(() => import("./../Modal"), {
  suspense: true,
});

interface VerifyModalProps {
  open: boolean;
  onClose: () => void;
}

const VerifyModal: React.FC<VerifyModalProps> = ({ open, onClose }) => {
  return (
    <Modal className="w-fit max-w-sm" onClose={onClose} visible={open}>
      <div className="p-4">
        <div className="flex justify-end ">
          <button onClick={onClose} aria-label="Close">
            <AiOutlineClose fontSize={20} />
          </button>
        </div>
        <VerificationSteps />

        <button
          onClick={onClose}
          className="bg-primary w-full py-2 text-white mt-2"
        >
          Ok
        </button>
      </div>
    </Modal>
  );
};

export default VerifyModal;
